<template>
  <base-modal modal-content-class="rest confirm_purch">
    <div class="content">
      <h1>{{ $_getTranslations.home_modals_confirm_purchase_purchase }}</h1>

      <p class="games-to-price">
        <span>{{ getBundleData.numberOfGames }}</span> {{ $_getTranslations.home_modals_confirm_purchase_games }} -
        <span>{{ getBundleData.price }}</span> {{ getBundleData.currencyCode }}
      </p>

      <p>{{ $_getTranslations.home_modals_confirm_purchase_pin_instructions }}</p>

      <base-digit-form-input
        v-model="formValues.pin"
        :label="$_getTranslations.home_modals_confirm_purchase_pin_enter_the_4"
        :invalid="pinInputValidationConfiguration.invalid"
        :max-length="pinSize"
        input-id="pin_sms"
      ></base-digit-form-input>

      <div v-if="pinInputValidationConfiguration.invalid" class="error_text">
        {{ pinInputValidationConfiguration.message }}
      </div>

      <base-button @button:click="purchaseBundle">
        {{ $_getTranslations.home_modals_confirm_purchase_pin_confirm_button }}
      </base-button>
    </div>
  </base-modal>
</template>

<script>
/* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import {mapGetters, mapActions, mapState, mapMutations} from 'vuex'
import BaseModal from '../../../common/modal/BaseModal'
import BaseButton from '../../../common/button/BaseButton'
import BaseDigitFormInput from '../../../common/formInput/BaseDigitFormInput'
import ConfirmPurchaseSuccessful from './ConfirmPurchaseSuccessful'
import ConfirmPurchaseForPinError from './ConfirmPurchaseForPinError'
import FailedPurchase from './FailedPurchase'
import translationMixin from '../../../../common/mixins/translation'
import modals from '../../../../common/modals'
import {apiResponseTypeEnum} from '../../../../constants/api'

export default {
  name: 'confirm-purchase-for-pin',
  components: {
    BaseModal,
    BaseButton,
    BaseDigitFormInput
  },
  mixins: [translationMixin],
  data () {
    return {
      formValues: {pin: ''},
      pinInputValidationConfiguration: {invalid: false, message: ''},
      pinSize: 4
    }
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForStore'
    ]),
    ...mapActions('profile', [
      'getUserLoginDetails',
      'chargePinCall'
    ]),
    showModal () {
      modals.setupCommonModal({
        afterHideCallback: () => {
          this.storeModalForStore(null)
        }
      })
    },
    validateForm () {
      const isPinRequiredRuleFailed = () => {
        if (!this.formValues.pin) {
          return {message: 'common_error_input_field_required'}
        }

        return null
      }

      const isPinContentCriteriaRuleFailed = () => {
        // const validationRegexPin = /^[0-9]{0,8}$/
        //
        // if (!this.formValues.pin.match(validationRegexPin)) {
        //   return {message: 'home_modals_confirm_purchase_verification_code_invalid'}
        // }

        return null
      }

      const errorConfiguration = isPinRequiredRuleFailed() || isPinContentCriteriaRuleFailed()

      return {
        invalid: !!errorConfiguration,
        configuration: errorConfiguration
      }
    },
    resetErrors () {
      if (this.pinInputValidationConfiguration.invalid) {
        this.pinInputValidationConfiguration.invalid = false
        this.pinInputValidationConfiguration.message = ''
      }
    },
    purchaseBundle () {
      this.resetErrors()

      const {invalid, configuration} = this.validateForm()

      if (invalid) {
        this.pinInputValidationConfiguration.invalid = true
        this.pinInputValidationConfiguration.message = this.$_translateText({key: configuration.message})

        return
      }

      this.getUserLoginDetails().then(() => {
        const bundleInfo = {
          bundleId: this.bundleId,
          pin: this.formValues.pin
        }

        this.chargePinCall({value: bundleInfo}).then(() => {
          if (this.chargePinResponse === apiResponseTypeEnum.WRONG_PIN) {
            this.pinInputValidationConfiguration.invalid = true
            this.pinInputValidationConfiguration.message = this.$_translateText({key: 'home_modals_confirm_purchase_verification_code_invalid'})

            return
          }

          if (this.chargePinResponse === apiResponseTypeEnum.OPERATION_SUCCESS) {
            this.$emit('bundlePurchase')
            this.storeModalForStore(ConfirmPurchaseSuccessful)
          } else if (this.chargePinResponse === apiResponseTypeEnum.NO_BALANCE) {
            this.storeModalForStore(FailedPurchase)
          } else {
            this.storeModalForStore(ConfirmPurchaseForPinError)
          }

          this.showModal()
        })
      })
    }
  },
  computed: {
    ...mapState('profile', [
      'chargePinResponse',
      'bundleId'
    ]),
    ...mapGetters('profile', [
      'getBundleData'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/modals/store/ConfirmPurchaseForPin.vue